(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["md-ai-comparison"] && !Shopify.designMode) return;
  try {
    

if (!customElements.get('mdai-image-compare')) {
  customElements.define('mdai-image-compare', class extends HTMLElement {
    connectedCallback() {
      if (this.initialized) return;
      requestAnimationFrame(() => this.initialize());
    }
    initialize() {
      if (this.initialized || !this.isConnected) return;
      const range = this.querySelector('input[type="range"]');
      const before = this.querySelector('[data-before]');
      const handle = this.querySelector('[data-handle]');
      if (!range || !before || !handle) return;
      this.initialized = true;
      const update = () => {
        const value = Math.max(0, Math.min(100, Number(range.value)));
        before.style.clipPath = `inset(0 ${100 - value}% 0 0)`;
        handle.style.left = `${value}%`;
      };
      range.addEventListener('input', update);
      let pointer = null;
      const move = (event) => {
        const box = this.getBoundingClientRect();
        range.value = String(Math.round((event.clientX - box.left) * 100 / box.width));
        update();
      };
      range.addEventListener('pointerdown', (event) => {
        if (!event.isPrimary || event.button !== 0) return;
        pointer = event.pointerId;
        range.setPointerCapture(pointer);
        range.focus({ preventScroll: true });
        event.preventDefault();
        move(event);
      });
      range.addEventListener('pointermove', (event) => {
        if (pointer === event.pointerId) move(event);
      });
      ['pointerup', 'pointercancel', 'lostpointercapture'].forEach(name => range.addEventListener(name, () => { pointer = null; }));
      update();
    }
  });
}


  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["md-interactive-banner"] && !Shopify.designMode) return;
  try {
    

if (!customElements.get('md-interactive-banner')) {
  customElements.define('md-interactive-banner', class extends HTMLElement {
    connectedCallback() {
      this.abort?.abort();
      this.abort = new AbortController();
      const signal = this.abort.signal;
      this.slides = [...this.querySelectorAll('[data-slide]')];
      this.buttons = [...this.querySelectorAll('[data-index]')];
      this.active = 0;
      this.paused = false;
      this.hovered = false;
      this.reduced = window.matchMedia('(prefers-reduced-motion: reduce)');
      this.mobile = window.matchMedia('(max-width: 749px)');
      this.mobile.addEventListener('change', () => { this.updateMobileHeight(); this.schedule(); }, { signal });
      const controls = this.querySelector('[data-controls]');
      if (controls) controls.hidden = false;
      this.addEventListener('click', event => {
        const button = event.target.closest('button');
        if (!button) return;
        if (button.hasAttribute('data-index')) this.show(Number(button.dataset.index), true);
        if (button.hasAttribute('data-prev')) this.show(this.active - 1, true);
        if (button.hasAttribute('data-next')) this.show(this.active + 1, true);

        this.schedule();
      }, { signal });
      this.addEventListener('mouseenter', () => { this.hovered = window.matchMedia('(hover: hover)').matches; this.schedule(); }, { signal });
      this.addEventListener('mouseleave', () => { this.hovered = false; this.schedule(); }, { signal });
      this.addEventListener('focusin', () => clearTimeout(this.timer), { signal });
      this.addEventListener('focusout', () => requestAnimationFrame(() => this.schedule()), { signal });
      document.addEventListener('visibilitychange', () => this.schedule(), { signal });
      this.reduced.addEventListener('change', () => this.schedule(), { signal });
      document.addEventListener('shopify:block:select', event => {
        const index = this.slides.findIndex(slide => slide.dataset.blockId === event.detail.blockId);
        if (index < 0) return;
        this.paused = true;
        this.show(index, false);
        this.schedule();
      }, { signal });
      this.querySelectorAll('.mdib-visual').forEach(visual => {
        const overlays = visual.querySelector('.mdib-overlays');
        if (!overlays) return;
        visual.closest('[data-slide]').addEventListener('pointermove', event => {
          if (this.reduced.matches || event.pointerType !== 'mouse') return;
          const bounds = visual.getBoundingClientRect();
          if (event.clientX < bounds.left || event.clientX > bounds.right || event.clientY < bounds.top || event.clientY > bounds.bottom) {
            overlays.style.setProperty('--float-x', '0px');
            overlays.style.setProperty('--float-y', '0px');
            return;
          }
          overlays.style.setProperty('--float-x', `${((event.clientX - bounds.left) / bounds.width - .5) * 16}px`);
          overlays.style.setProperty('--float-y', `${((event.clientY - bounds.top) / bounds.height - .5) * 16}px`);
        }, { signal });
        visual.closest('[data-slide]').addEventListener('pointerleave', () => {
          overlays.style.setProperty('--float-x', '0px');
          overlays.style.setProperty('--float-y', '0px');
        }, { signal });
      });
      this.updateMobileHeight();
      this.addEventListener('load', () => this.updateMobileHeight(), { capture: true, signal });
      document.fonts?.ready.then(() => { if (this.isConnected) this.updateMobileHeight(); });
      this.sizeObserver?.disconnect();
      this.observedWidth = this.getBoundingClientRect().width;
      this.sizeObserver = new ResizeObserver(entries => {
        const width = entries[0].contentRect.width;
        if (Math.abs(width - this.observedWidth) < 1) return;
        this.observedWidth = width;
        this.updateMobileHeight();
      });
      this.sizeObserver.observe(this);
      this.schedule();
    }
    updateMobileHeight() {
      const stage = this.querySelector('.mdib-stage');
      if (!stage) return;
      if (!this.mobile.matches) {
        stage.style.removeProperty('--mobile-stable-height');
        return;
      }
      let height = 0;
      this.slides.forEach(slide => {
        const hidden = slide.hidden;
        slide.classList.add('mdib-slide--measuring');
        slide.hidden = false;
        height = Math.max(height, slide.getBoundingClientRect().height);
        slide.hidden = hidden;
        slide.classList.remove('mdib-slide--measuring');
      });
      if (height) stage.style.setProperty('--mobile-stable-height', `${Math.ceil(height)}px`);
    }
    show(index, announce) {
      if (!this.slides.length) return;
      const next = (index + this.slides.length) % this.slides.length;
      if (next === this.active) return;
      const previous = this.slides[this.active];
      const incoming = this.slides[next];
      const stage = this.querySelector('.mdib-stage');
      const oldHeight = stage?.getBoundingClientRect().height;
      this.slideAnimations?.forEach(animation => animation.cancel());
      this.slides.forEach(slide => {
        slide.classList.remove('mdib-slide--leaving');
        slide.inert = false;
        slide.removeAttribute('aria-hidden');
        slide.hidden = slide !== incoming;
      });
      this.active = next;
      const token = this.transitionToken = (this.transitionToken || 0) + 1;
      if (!this.reduced.matches && incoming.animate) {
        previous.hidden = false;
        previous.classList.add('mdib-slide--leaving');
        previous.inert = true;
        previous.setAttribute('aria-hidden', 'true');
        const options = { duration: 500, easing: 'cubic-bezier(.22,.61,.36,1)' };
        const fadeIn = incoming.animate([{ opacity: 0 }, { opacity: 1 }], options);
        const fadeOut = previous.animate([{ opacity: 1 }, { opacity: 0 }], options);
        this.slideAnimations = [fadeIn, fadeOut];
        if (stage && oldHeight && !this.mobile.matches) {
          const height = incoming.getBoundingClientRect().height;
          this.slideAnimations.push(stage.animate([{ height: `${oldHeight}px` }, { height: `${height}px` }], options));
        }
        fadeOut.finished.then(() => {
          if (this.transitionToken !== token) return;
          previous.hidden = true;
          previous.classList.remove('mdib-slide--leaving');
          previous.inert = false;
          previous.removeAttribute('aria-hidden');
        }).catch(() => {});
      }
      this.buttons.forEach((button, i) => button.setAttribute('aria-pressed', String(i === this.active)));
      const count = `${this.active + 1} / ${this.slides.length}`;
      const counter = this.querySelector('[data-count]');
      if (counter) counter.textContent = count;
      if (announce) this.querySelector('[data-status]').textContent = `${count}: ${this.buttons[this.active].textContent}`;
    }
    schedule() {
      clearTimeout(this.timer);
      const autoplay = this.mobile.matches ? this.dataset.mobileAutoplay : this.dataset.autoplay;
      if (autoplay !== 'true' || this.slides.length < 2 || this.paused || this.hovered || this.reduced.matches || document.hidden || this.contains(document.activeElement) || window.Shopify?.designMode) return;
      this.timer = setTimeout(() => { this.show(this.active + 1, false); this.schedule(); }, Number(this.dataset.interval) || 7000);
    }
    disconnectedCallback() { this.sizeObserver?.disconnect(); clearTimeout(this.timer); this.slideAnimations?.forEach(animation => animation.cancel()); this.abort?.abort(); }
  });
}

  } catch(e) { console.error(e); }
})();
})();
